/**
 * @generated SignedSource<<de926d7d8ccc1542cf88031a8651e65d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AgentParametersQuery$variables = {
  locator: string;
};
export type AgentParametersQuery$data = {
  readonly agentRest: {
    readonly " $fragmentSpreads": FragmentRefs<"AgentParameters_agent">;
  } | null | undefined;
};
export type AgentParametersQuery = {
  response: AgentParametersQuery$data;
  variables: AgentParametersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "agentLocator",
    "variableName": "locator"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentParametersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AgentRest",
        "kind": "LinkedField",
        "name": "agentRest",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AgentParameters_agent"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentParametersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AgentRest",
        "kind": "LinkedField",
        "name": "agentRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Properties",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Property",
                "kind": "LinkedField",
                "name": "property",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ef82f09972d99eb893214eba3d27e21",
    "id": null,
    "metadata": {},
    "name": "AgentParametersQuery",
    "operationKind": "query",
    "text": "query AgentParametersQuery(\n  $locator: String!\n) {\n  agentRest(agentLocator: $locator) {\n    ...AgentParameters_agent\n    _id\n  }\n}\n\nfragment AgentParameters_agent on AgentRest {\n  properties {\n    count\n    ...filterSearch_parameters\n  }\n}\n\nfragment filterSearch_parameters on Properties {\n  property {\n    name\n    value\n  }\n}\n"
  }
};
})();

(node as any).hash = "a141c397941de7eb28a03840a00b0f45";

export default node;
